export const CONTACT_EMAIL_PARTS = {
  user: "info",
  domain: "visseraco",
  tld: "com",
};

export function buildEmail(parts = CONTACT_EMAIL_PARTS) {
  return `${parts.user}@${parts.domain}.${parts.tld}`;
}

export function obfuscateEmail(parts = CONTACT_EMAIL_PARTS) {
  return `${parts.user} [at] ${parts.domain}.${parts.tld}`;
}
